import React, { FC } from "react";
import { Button, InputField } from "../forms";
import { ModalPropsDTO } from "../../typings/generic";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../utils/regex";
import { ListPicker } from "../generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { onAddDept } from "../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";

const AddDepartment = (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const companypicker = usePickerhook();
  const rolepicker = usePickerhook();
  const { setLoading } = useStateSetter();
  const watchedFields = watch(["deptname", "desc"]);
  const { SelectedOrg, config } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );
  const onSubmit = async (data: any) => {
    console.log(data);

    let postdata = {
      deptName: data.deptname,
      description: data.desc,
      organizationID: companypicker.pickedRole.code,
    };
    setLoading(true);
    try {
      var response = await onAddDept(postdata, config);
      if (response.success) {
        toast.success(response.message);
        setLoading(false);
      }
      setLoading(false);
      props.show(false);
      props.refresh(false);
    } catch (e: any) {
      console.log(e);

      toast.error(e);
    }

  };
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col justify-center items-center rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">Add Department</p>
          <div className=" flex w-full flex-col ">
            <ListPicker
              fullwidth
              hook={companypicker}
              title="Company"
              list={UserOrgs.map((i) => {
                return { name: i.orgName, code: i.id };
              })}
            />
            <InputField
              name="deptname"
              title="Name"
              placeholder={"Department name"}
              control={control}
              rules={{
                required: "Department name is required",
                pattern: {
                  value: textReg,
                  message: "Invalid department name",
                },
              }}
            />

            <InputField
              name="desc"
              title="Description"
              placeholder={"Description"}
              control={control}
              isTextArea
              rules={{
                required: "description is required",
                pattern: {
                  value: textReg,
                  message: "Invalid description",
                },
              }}
            />
          </div>
          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add Department"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDepartment;
